export const GAS_OPTIONS = [
    { value: 'co2', label: 'CO₂' },
    { value: 'ch4', label: 'CH₄' },
    { value: 'n2o', label: 'N₂O' },
];